import React from 'react';
import * as Yup from "yup";

const customerInitData = {
    "id": 0,
    "customerNumber": 0,
    "name": "",
    "emrVendorId": 0,
    "codeInSoftware": null,
    "enterSeverityCodes": null,
    "severityCodePreferences": null,
    "useOurWorksheets": null,
    "returnReviewToId": null,
    "reviewReturnMethodId": null,
    "messageLineOfEmail": null,
    "changeVisitStatusLocation": null,
    "change485StatusLocation": null,
    "enterNoteStatingReviewComplete": null,
    "validationToolUsedId": null,
    "referralInfoContactId": null,
    "codingClarificationContactId": null,
    "oasisAnswerClarificationContactId": null,
    "userAccountRequestContactId": null,
    "codeVerificationPreferenceId": null,
    "chartOnHoldDocumentationMethod": null,
    "waitingOnAgencyPreference": null,
    "waitingOnAgencyEscalationContactId": null,
    "groundControlCode": null,
    "sharedLoginInfo": null,
    "miscNotes": null,
    "homecareQueueId": null,
    "hospiceQueueId": null,
    "stateName": "Active",
    "users": [],
    "phoneNumbers": null,
    "isParentAccount": false,
    "parentAccountId": null,
    "state": 100
}

const getContactInfo = (id, contacts) => {
    var result = contacts.filter(obj => {
        return obj.id === id;
    });
    if (result.length > 0) {
        return (
            <> {result[0].fullName} <br /> {result[0].emailAddress} <br /> {result[0].phoneNumber}</>
        );
    }
    return <> Undefined contact<br />&nbsp;<br />&nbsp;</>;
}

const customerValidationSchema = {
    name: Yup.string().required('Account name is required.')
        .min(5, 'Account name must contain more than five characters.')
        .max(300, 'Account name must have less than 300 characters.'),
    customerNumber: Yup.number().min(1, 'Customer number is required.'),
    emrVendorId: Yup
        .number()
        .when("isParentAccount", {
            is: false,
            then: Yup.number().nullable().min(1, 'EMR Vendor is required.')
        }),
    homecareQueueId: Yup
        .number()
        .when("isParentAccount", {
            is: false,
            then: Yup.number().required('Homecare queue is required.').min(1, 'Homecare queue is required.').nullable()
        }),
    hospiceQueueId: Yup
        .number()
        .when("isParentAccount", {
            is: false,
            then: Yup.number().required('Hospice queue is required.').min(1, 'Hospice queue is required.').nullable()
        }),
    groundControlCode: Yup.string().max(3, 'Ground control code must be three characters or less.').nullable()
};


export { customerInitData, customerValidationSchema, getContactInfo }